var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPointWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31285 11.9266C9.31285 13.9426 7.67466 15.5823 5.65504 15.5823C3.63808 15.5823 2.00003 13.9425 2.00003 11.9266C2.00003 9.90656 3.63822 8.26953 5.65504 8.26953C7.67473 8.26953 9.31285 9.90667 9.31285 11.9266Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2368 7.61609C9.95484 7.87011 9.86934 8.27727 10.0254 8.62327C10.239 9.09713 10.817 9.28031 11.2646 9.01604L17.9192 5.08724C18.3589 4.82766 18.5324 4.27852 18.3217 3.81344L17.7663 2.58757C17.487 1.97117 16.6889 1.80433 16.1861 2.25724L10.2368 7.61609ZM11.041 11.0397C10.5806 11.0789 10.2269 11.464 10.2269 11.9261C10.2269 12.3882 10.5806 12.7733 11.041 12.8125L21.0254 13.662C21.609 13.7116 22.1102 13.2513 22.1102 12.6656V11.1865C22.1102 10.6008 21.609 10.1405 21.0254 10.1901L11.041 11.0397ZM10.0256 15.3849C9.86957 15.7307 9.95499 16.1378 10.2369 16.3917L16.1864 21.7508C16.6892 22.2036 17.4872 22.0369 17.7665 21.4205L18.3217 20.1956C18.5325 19.7305 18.359 19.1813 17.9193 18.9217L11.2641 14.9925C10.8168 14.7284 10.2393 14.9114 10.0256 15.3849Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPointWhite);
export default __webpack_public_path__ + "static/media/view-point-white.9cc6b985f7b8c4fa4b039eb1d5d44b20.svg";
export { ForwardRef as ReactComponent };